import React from "react";

import {
  FaFileExport,
} from "react-icons/fa";

import Button from "../../../components/Button/Button";

import {
  extractEventCategories,
} from "./utils/calendarUtils";

const HEADERS = [
  "Titre",
  "Discipline",
  "Organisateur",
  "Type",
  "Niveau",
  "Lieu",
  "Horaires",
  "Date début",
  "Date fin",
  "Catégories d'âge",
  "Photo",
  "Document PDF",
  "Suivi compétition",
  "Description (HTML)",
];

function toFRDateOnly(value) {
  if (!value) return "";

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return "";
  }

  return date.toLocaleDateString(
    "fr-FR",
    {
      timeZone: "Europe/Paris",
    }
  );
}

function eventsToRows(events = []) {
  return events.map((event) => ({
    Titre: event.titre || "",

    Discipline:
      event.discipline_event || "",

    Organisateur:
      event.organisateur || "",

    Type: event.type_event || "",

    Niveau:
      event.level_event || "",

    Lieu: event.lieu_event || "",

    Horaires:
      event.horaire_event || "",

    "Date début":
      toFRDateOnly(event.start),

    "Date fin":
      toFRDateOnly(event.end),

    "Catégories d'âge":
      extractEventCategories(
        event.cate_event
      ).join(", "),

    Photo: event.photo_url || "",

    "Document PDF":
      event.agenda_url || "",

    "Suivi compétition":
      event.suivi_event || "",

    "Description (HTML)":
      event.description
        ? String(event.description)
        : "",
  }));
}

function autoSizeWorksheet(
  worksheet,
  rows
) {
  worksheet["!cols"] = HEADERS.map(
    (header) => {
      const contentLengths = rows.map(
        (row) =>
          String(row[header] || "").length
      );

      const maximumLength = Math.max(
        header.length,
        ...contentLengths,
        10
      );

      return {
        wch: Math.min(
          maximumLength + 2,
          55
        ),
      };
    }
  );
}

export default function ExportEventsButton({
  events = [],
  filename = "calendrier_ligue.xlsx",
}) {
  const disabled =
    !Array.isArray(events) ||
    events.length === 0;

  const onExport = async () => {
    const rows = eventsToRows(events);

    try {
      const xlsx = await import("xlsx");

      const worksheet =
        xlsx.utils.json_to_sheet(rows, {
          header: HEADERS,
          skipHeader: false,
        });

      autoSizeWorksheet(
        worksheet,
        rows
      );

      const workbook =
        xlsx.utils.book_new();

      xlsx.utils.book_append_sheet(
        workbook,
        worksheet,
        "Calendrier"
      );

      xlsx.writeFile(
        workbook,
        filename
      );
    } catch (error) {
      console.error(
        "Export XLSX indisponible, utilisation du CSV :",
        error
      );

      const escapeCsvValue = (value) => {
        const text = String(
          value ?? ""
        ).replace(/"/g, '""');

        return `"${text}"`;
      };

      const csvContent =
        "\uFEFF" +
        [
          HEADERS.join(";"),

          ...rows.map((row) =>
            HEADERS.map((header) =>
              escapeCsvValue(
                row[header]
              )
            ).join(";")
          ),
        ].join("\n");

      const blob = new Blob(
        [csvContent],
        {
          type: "text/csv;charset=utf-8",
        }
      );

      const url =
        URL.createObjectURL(blob);

      const link =
        document.createElement("a");

      link.href = url;

      link.download = filename.replace(
        /\.xlsx?$/i,
        ".csv"
      );

      document.body.appendChild(link);
      link.click();
      link.remove();

      URL.revokeObjectURL(url);
    }
  };

  return (
    <Button
      text="Exporter Excel"
      icon={FaFileExport}
      onClick={onExport}
      disabled={disabled}
      title={
        disabled
          ? "Aucun événement à exporter"
          : "Exporter les événements filtrés"
      }
      variant="outline"
    />
  );
}